import { render } from "./FormAbsenKeluar.vue?vue&type=template&id=506c07f0"
import script from "./FormAbsenKeluar.vue?vue&type=script&lang=js"
export * from "./FormAbsenKeluar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__